import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, ShieldCheck, Search, HeartHandshake, BookOpen, ArrowRight } from 'lucide-react';

const values = [
  { icon: ShieldCheck, title: 'Safe by default', body: 'Contraindications and cautions surface first, never buried in fine print.' },
  { icon: Search, title: 'Symptom-first', body: 'Start from how you feel — we guide you to the plants and preparations that fit.' },
  { icon: HeartHandshake, title: 'Gentle & honest', body: 'Educational, never prescriptive. We help you learn, not replace your doctor.' },
  { icon: BookOpen, title: 'Rooted in tradition', body: 'Time-honoured herbalism, presented with modern clarity and care.' }
];

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-5 py-12 min-h-[70vh]">
      <span className="w-14 h-14 rounded-2xl bg-botanica-greenLight flex items-center justify-center mb-6">
        <Leaf className="w-7 h-7 text-botanica-green" />
      </span>
      <h1 className="font-serif text-4xl md:text-5xl text-botanica-ink leading-tight mb-5">
        A pocket herbalist for the whole family.
      </h1>
      <p className="text-botanica-muted text-lg leading-relaxed max-w-2xl mb-4">
        Your Herbal Companion began with a simple wish: to make natural remedies feel approachable, trustworthy and safe.
        We blend the wisdom of traditional herbalism with clear, modern guidance — so you can care for
        the people you love with confidence.
      </p>
      <p className="text-botanica-muted leading-relaxed max-w-2xl mb-12">
        With 200+ herbs and essential oils, 52 guided recipes, a first-aid kit builder, a built-in safety
        checker, and Sage — your gentle AI companion — everything you need is in one calm, uncluttered place.
      </p>

      <div className="grid sm:grid-cols-2 gap-5 mb-14">
        {values.map((v) => (
          <div key={v.title} className="bg-botanica-card/60 rounded-3xl p-6 border border-botanica-card">
            <span className="w-11 h-11 rounded-xl bg-botanica-greenLight flex items-center justify-center mb-4">
              <v.icon className="w-5 h-5 text-botanica-green" />
            </span>
            <h3 className="font-serif text-xl text-botanica-ink mb-1.5">{v.title}</h3>
            <p className="text-sm text-botanica-muted leading-relaxed">{v.body}</p>
          </div>
        ))}
      </div>

      <div className="rounded-3xl bg-botanica-greenLight p-8 text-center">
        <h2 className="font-serif text-2xl text-botanica-ink mb-2">Ready to explore?</h2>
        <p className="text-sm text-botanica-greenDark mb-6 max-w-md mx-auto">
          Dive into the library, save your favourites, and let Sage guide the way.
        </p>
        <Link
          to="/library"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-botanica-green text-white font-medium hover:bg-botanica-greenDark transition-colors"
        >
          Open the library <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <p className="text-xs italic text-botanica-muted text-center mt-8">
        Your Herbal Companion is educational only and does not provide medical advice.
      </p>
    </div>
  );
}
